import GATSBY_COMPILED_MDX from "/opt/build/repo/content/guides/nootropics-vs-neurofeedback-focus.mdx";
import React from "react";
import {graphql} from "gatsby";
import {Box} from "reflexbox";
import styled from "styled-components";
import Layout from "../components/layout";
import {Seo} from "../components/seo";
import {PageContainer} from "../components/PageContainer";
import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {GuideHero} from "../components/guides/GuideHero";
import {GuideFAQs} from "../components/guides/GuideFAQs";
import {GuideAuthor} from "../components/guides/GuideAuthor";
import {GuideJsonLd} from "../components/guides/GuideJsonLd";
import {LeadMagnetForm} from "../components/guides/LeadMagnetForm";
import {PublishedSlugsProvider, CrownPriceProvider} from "../components/guides/MdxProvider";
import * as colors from "../styles/colors";
const CategoryLabel = (styled.div)`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${colors.primary};
  margin-bottom: 12px;
`;
const GuideTitle = (styled.h1)`
  font-size: 42px;
  font-weight: 700;
  color: ${colors.light};
  line-height: 120%;
  margin: 0 0 16px 0;

  @media (max-width: 640px) {
    font-size: 30px;
  }
`;
export const Head = ({data, location}) => {
  const {frontmatter} = data.mdx;
  return React.createElement(React.Fragment, null, React.createElement(Seo, {
    title: frontmatter.metaTitle || frontmatter.title,
    description: frontmatter.description,
    location: location
  }), React.createElement(GuideJsonLd, {
    frontmatter: frontmatter
  }));
};
function GuideTemplate({data, children, pageContext}) {
  const {frontmatter} = data.mdx;
  const publishedSlugs = new Set(pageContext.publishedSlugs || []);
  const crownPrice = data.shopifyProduct?.priceRangeV2?.maxVariantPrice?.amount;
  return React.createElement(PublishedSlugsProvider, {
    slugs: publishedSlugs
  }, React.createElement(CrownPriceProvider, {
    price: crownPrice
  }, React.createElement(Layout, null, React.createElement(Header), React.createElement(PageContainer, null, React.createElement(Box, {
    mt: [0, 10],
    mb: [0],
    width: "100%"
  }, React.createElement(CategoryLabel, null, "Guide"), React.createElement(GuideTitle, null, frontmatter.hero?.title || frontmatter.title), React.createElement(GuideAuthor, {
    publishedDate: frontmatter.publishedDate
  })), React.createElement(Box, {
    mb: [20, 30],
    width: "100%"
  }), React.createElement(GuideHero, {
    hero: frontmatter.hero,
    heroCta: frontmatter.heroCta
  }), React.createElement(Box, {
    className: "guide-content",
    width: "100%",
    color: colors.text,
    fontSize: [16, 18],
    style: {
      lineHeight: "180%"
    }
  }, children), React.createElement(LeadMagnetForm, {
    slug: frontmatter.slug
  }), React.createElement(GuideFAQs, {
    faqs: frontmatter.faqs
  }), React.createElement(Box, {
    pb: [50]
  })), React.createElement(Footer))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(GuideTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query GuideBySlug($slug: String!) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        title
        metaTitle
        description
        slug
        published
        publishedDate(formatString: "MMMM YYYY")
        category
        featured
        hero {
          title
          answer
          detail
          subtitle
        }
        heroCta {
          label
          href
          subtext
          linkToAppStore
        }

        jsonLdDates {
          datePublished
          dateModified
        }
        faqs {
          question
          answer
        }
        howToSteps {
          name
          text
        }
        listing {
          icon
          color
          title
          description
        }
      }
    }
    shopifyProduct(
      shopifyId: { eq: "gid://shopify/Product/6540456296499" }
    ) {
      priceRangeV2 {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
    }
  }
`;
